import { Grid, withWidth } from "@material-ui/core";
import Container from "@mui/material/Container";
import React from "react";
import HPCImage from "../../../../../assert/images/HPCImage.webp";
import NISTBadge from "../../../../../assert/images/NISTBadge.webp";
import researchStyles from "./styles.module.css";

function Offering(props) {
  const manageXResearch = {
    title: "Secure and Compliant Research",
    paragraph:
      "Dedicated Secure Research Enclave made available for researchers to use in a secure manner while working on restricted data sets. The solution features robust mechanisms for control over user access to the environment and also over movement of data in or out of scope for analysis so it is ideal for working with restricted data sets",
    list: [
      "Monitoring and Auditing",
      "NIST 800-171 compliance",
      "Privacy & security that meets industry-specific needs"
    ]
  };
  const capabilities = {
    title: "Capabilities",
    subTitle: "Functional capabilities of the ManageX Research Platform",
    paragraph:
      "Take full advantage of the power and scale of global cloud services without disrupting your workflows or breaking your piggybank. ManageX Research is your simplified pathway to accelerating your time to results."
  };

  let allCategory = [
    {
      name: "Versatile workspaces",
      shortDesc:
        "Reproducible yet customizable workspaces enabled precisely for your research, crafted from one or more automation templates",
      points: [
        "Purpose-built interfaces that are robust & responsive",
        "Enables isolated applications to interdependent workflows",
        "Persistent or on-demand as research needs dictate",
        "Workspaces evolve with the research journey"
      ]
    },
    {
      name: "Automated templates",
      shortDesc:
        "Comprehensive & composable means for deployments that capture all the nuances of any research use case",
      points: [
        "Deploys isolated VMs to shared platforms for sophisticated & collaborative research",
        "Holistic approach accounts for data, compute, network, and visualization"
      ]
    },
    {
      name: "Management hub",
      shortDesc:
        "Research reimagined as a managed service on the cloud with monitoring, reporting, security & compliance, cost controls, and more …",
      points: [
        "Visible & actionable monitoring & reporting",
        "NIST 800-171 compliance",
        "Privacy & security that meets industry-specific needs",
        "Unified billing with zero-overage guarantees*"
      ]
    },
    {
      name: "Service concierge",
      shortDesc:
        "Trusted advice on research solutions from cloud architects to ensure the research goals are mapped to cloud services for to achieve productive research",
      points: [
        "Technical expertise for every phase of every project – from conception through to production-quality results",
        "Support & training customized to your needs",
        "Secure, collaborative  enclaves for research"
      ]
    }
  ];

  return (
    <React.Fragment>
      {/* manageX Research */}
      <section className={researchStyles.manageXResearch}>
        <Container maxWidth="xl">
          <Grid container alignItems="center" spacing={2}>
            <Grid item md={9}>
              <h3
                className={
                  researchStyles.sectionTitle + " " + researchStyles.titleBlue
                }
              >
                {manageXResearch.title}
              </h3>
              <p className={researchStyles.manageXResearchDescription}>{manageXResearch.paragraph}</p>
              <ul>
                {manageXResearch.list.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>{" "}
            </Grid>
            <Grid item md={3} className={researchStyles.complaintImage}>
              <img src={NISTBadge} alt="NIST Badge" />
            </Grid>
          </Grid>
        </Container>
      </section>
      <section className={researchStyles.capabilities}>
        <Container maxWidth="xl">
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
          >
            <Grid item md={6}>
              <h3 className={researchStyles.sectionTitle}>
                {capabilities.title}
              </h3>
              <h5 className={researchStyles.titleSubtitle}>
                {capabilities.subTitle}
              </h5>
              <p>
                <span
                  style={{ cursor: "pointer", color: "#42ABE9" }}
                  onClick={() => {
                    props.handleMenuClick("requestTrail");
                  }}
                >
                  Sign up
                </span>{" "}
                for access to one of our Workspaces.
              </p>
              <p>{capabilities.paragraph}</p>
            </Grid>
            <Grid item md={4}>
              <img src={HPCImage} alt="Offer" />
            </Grid>
            <Grid item md={12}>
              {allCategory.map((category, index) => (
                <div
                  className={researchStyles.capabilitiesCategory}
                  key={index}
                >
                  <h3 className={researchStyles.sectionTitle}>
                    {category.name}
                  </h3>
                  <p className={researchStyles.description}>{category.shortDesc}</p>
                  <ul className={researchStyles.descriptionList}>
                    {category.points.map((point, index) => (
                      <li key={index}>{point}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </Grid>
          </Grid>
        </Container>
      </section>
    </React.Fragment>
  );
}

export default withWidth()(Offering);
